import React, { useEffect, useState } from 'react';

import SectionHeader from './components/SectionHeader';
import SideNav from './components/SideNav';
import UserProfile from './components/UserProfile';

const MenuDrawer = (props) => {
    const [expandedSections, setExpandedSections] = useState({
        products: false,
        appointments: false,
    });
    const [logo, setLogo] = useState(null);

    useEffect(() => {
        let logo = localStorage.getItem('lg');
        setLogo(logo);
    }, []);

    const toggleSection = (section) => {
        setExpandedSections((prev) => ({
            ...prev,
            [section]: !prev[section],
        }));
    };

    if (!props.visible) return null;

    return (
        <>
            {/* Backdrop */}
            <div className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden" onClick={props.onClose} />

            {/* Drawer */}
            <div
                className={`fixed top-0 left-0 h-screen h-[100dvh] w-full bg-white z-50 transform transition-transform duration-300 ease-in-out lg:hidden ${
                    props.visible ? 'translate-x-0' : '-translate-x-full'
                }`}
            >
                {/* Header */}
                <div className="flex items-center justify-between p-4 border-b border-gray-200 flex-shrink-0">
                    <div className="flex items-center space-x-3">
                        <div className="w-8 h-8 text-blue-600">
                            {logo ? (
                                <img
                                    src={logo}
                                    alt="Logo"
                                    className="w-full h-full cursor-pointer"
                                    onClick={() => props.goToPage('/member/register-product')}
                                />
                            ) : (
                                <svg
                                    viewBox="0 0 48 48"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="cursor-pointer"
                                    onClick={() => props.goToPage('/member/register-product')}
                                >
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M24 18.4228L42 11.475V34.3663C42 34.7796 41.7457 35.1504 41.3601 35.2992L24 42V18.4228Z"
                                        fill="currentColor"
                                    ></path>
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M24 8.18819L33.4123 11.574L24 15.2071L14.5877 11.574L24 8.18819ZM9 15.8487L21 20.4805V37.6263L9 32.9945V15.8487ZM27 37.6263V20.4805L39 15.8487V32.9945L27 37.6263ZM25.354 2.29885C24.4788 1.98402 23.5212 1.98402 22.646 2.29885L4.98454 8.65208C3.7939 9.08038 3 10.2097 3 11.475V34.3663C3 36.0196 4.01719 37.5026 5.55962 38.098L22.9197 44.7987C23.6149 45.0671 24.3851 45.0671 25.0803 44.7987L42.4404 38.098C43.9828 37.5026 45 36.0196 45 34.3663V11.475C45 10.2097 44.2061 9.08038 43.0155 8.65208L25.354 2.29885Z"
                                        fill="currentColor"
                                    ></path>
                                </svg>
                            )}
                        </div>
                    </div>
                    <button
                        onClick={props.onClose}
                        className="p-2 rounded-md text-gray-500 hover:text-gray-700 active:text-gray-700 hover:bg-gray-100 active:bg-gray-100 transition-colors touch-manipulation"
                    >
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M6 18L18 6M6 6l12 12"
                            ></path>
                        </svg>
                    </button>
                </div>

                {/* Menu Content Container - Single scrollable area */}
                <div className="flex-1 overflow-y-auto" style={{ height: 'calc(100% - 73px)' }}>
                    <div className="px-4 py-4 space-y-2">
                        {/* Products Section */}
                        <div className="space-y-1">
                            <SectionHeader
                                title="My Devices"
                                icon={
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
                                    ></path>
                                }
                                isExpanded={expandedSections.products}
                                onToggle={() => toggleSection('products')}
                            />

                            {expandedSections.products && (
                                <div className="pl-10 space-y-1">
                                    <SideNav
                                        name="Register Product"
                                        route="/member/register-product"
                                        goToPage={props.goToPage}
                                        curPath={props.curPath}
                                    />
                                    <SideNav
                                        name="View Warranty"
                                        route="/member/view-warranty"
                                        goToPage={props.goToPage}
                                        curPath={props.curPath}
                                    />
                                </div>
                            )}
                        </div>

                        {/* Appointments Section */}
                        <div className="space-y-1">
                            <SectionHeader
                                title="Service & Support"
                                icon={
                                    <>
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth="2"
                                            d="M8 7V3a1 1 0 011-1h6a1 1 0 011 1v4h3a1 1 0 011 1v1H5V8a1 1 0 011-1h2z"
                                        ></path>
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth="2"
                                            d="M5 10v9a1 1 0 001 1h12a1 1 0 001-1v-9"
                                        ></path>
                                    </>
                                }
                                isExpanded={expandedSections.appointments}
                                onToggle={() => toggleSection('appointments')}
                            />

                            {expandedSections.appointments && (
                                <div className="pl-10 space-y-1">
                                    <SideNav
                                        name="Schedule Appointment"
                                        route="/member/book-appointment"
                                        goToPage={props.goToPage}
                                        curPath={props.curPath}
                                    />
                                    <SideNav
                                        name="View Appointments"
                                        route="/member/view-booking-appointment"
                                        goToPage={props.goToPage}
                                        curPath={props.curPath}
                                    />
                                    <SideNav
                                        name="Service History"
                                        route="/member/view-service-case"
                                        goToPage={props.goToPage}
                                        curPath={props.curPath}
                                    />
                                </div>
                            )}
                        </div>

                        {/* User Profile Section - Now part of the scrollable content */}
                        <div className="mt-8 pt-4">
                            <UserProfile goToPage={props.goToPage} curPath={props.curPath} logout={props.logout} />
                        </div>

                        {/* Bottom padding to ensure logout button is fully accessible */}
                        <div className="pb-8" />
                    </div>
                </div>
            </div>
        </>
    );
};

export default MenuDrawer;
